'use strict';

var React = require('react');
require('@amzn/stencil-react-components/icons');
var SurgePremium = require('./SurgePremium-9eee1b19.js');
var layout = require('@amzn/stencil-react-components/layout');
var text = require('@amzn/stencil-react-components/text');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/*
 * NOTE:
 *
 * This source file was temporarily copied from the 'native-components' package.  Minimal changes
 * were made to use the Stencil web package and associated APIs to provide web support for this
 * component.  This is phase 1 of a multi-phase process to align Stencil native and web APIs so
 * we can more easily manage a single code base for both native and web.  When possible, this
 * component will be re-unified with its native counterpart and duplicate code removed.
 *
 * Ref: https://sim.amazon.com/issues/AtoZPirates-483
 */
exports.VisibilityStatus = void 0;

(function (VisibilityStatus) {
  VisibilityStatus["PUBLIC"] = "public";
  VisibilityStatus["PRIVATE"] = "private";
})(exports.VisibilityStatus || (exports.VisibilityStatus = {}));

/*
 * NOTE:
 *
 * This source file was temporarily copied from the 'native-components' package.  Minimal changes
 * were made to use the Stencil web package and associated APIs to provide web support for this
 * component.  This is phase 1 of a multi-phase process to align Stencil native and web APIs so
 * we can more easily manage a single code base for both native and web.  When possible, this
 * component will be re-unified with its native counterpart and duplicate code removed.
 *
 * Ref: https://sim.amazon.com/issues/AtoZPirates-483
 */

function DataVisibilityStatus(_ref) {
  var status = _ref.status,
      label = _ref.label;
  return /*#__PURE__*/React__default["default"].createElement(layout.Row, {
    gridGap: "S200",
    alignItems: "center"
  }, status === exports.VisibilityStatus.PUBLIC ? /*#__PURE__*/React__default["default"].createElement(SurgePremium.IconEye, null) : /*#__PURE__*/React__default["default"].createElement(SurgePremium.IconInvisible, null), /*#__PURE__*/React__default["default"].createElement(text.Text, {
    color: "neutral60",
    fontSize: "T200"
  }, label));
}

exports.DataVisibilityStatus = DataVisibilityStatus;
//# sourceMappingURL=DataVisibilityStatus-270463ed.js.map
